<template>
	<div id="topinfo">
		<div class="zt1" >
		    <!-- 顶部时间 -->
		    <div class="shij">
		      <span>
						{{time}}
					</span>
		    </div>
		    <div class="shijy">
		        <ul>
		            <li>
		                <a href="http://vr.itbx.cc/">首页</a>
		            </li>
		            <li>
		                <a href="http://wpa.qq.com/msgrd?v=3&uin=368783093&site=qq&menu=yes" target="_blank">联系站长</a>
		            </li>
		            <li>
		                <a style="color: aliceblue;" @click="backlogin">{{name}}</a>
		            </li>
		        </ul>
		    </div>
		</div>
		<div class="dbu">
		    <img src="~assets/logo.png" alt="">
		    <div class="dbu2">
		        <ul style="padding: 0; margin:0;">
		            <li>
		                <input type="text" v-model="value" placeholder="请输入需要的软件名称">
		                <button @click="soso">搜索</button>
		            </li>
		        </ul>
		    </div>
        <el-select style="width: 100px;float: right;margin-top: 43px; margin-right: 10px;" v-model="about" placeholder="请选择">
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
		</div>
		<marquee>本站将逐步彻查删除疑似违规/侵权内容资源，内容将都是自己测试可用再发出的，非某些垃圾站不测试就发问题一大堆。如遇欺诈广告或损害用户利益请第一时间联系站长处理!</marquee>
	</div>
</template>

<script>

	export default{
		name:'topinfo',
		data(){
			return{
        name:'点击登录',
				time:null,
        value:null,
        about:'phonesoso',
        options: [{
          value: 'phonesoso',
          label: '一体机'
        }, {
          value: 'pcsoso',
          label: '电脑'
        }],
			}
		},
		mounted() {
			var date = new Date();
			this.time="今天是：" + date.getFullYear() + "年" + (date.getMonth() + 1) + "月" + date.getDate() + "日" + " 星期" + "日一二三四五六".charAt(date.getDay())
    },
		methods:{
			soso(){
				this.$bus.$emit('soso',this.value,this.about)
			},
      backlogin(){
        localStorage.clear()
        this.$router.replace('/login')
      }
		}
	}
</script>

<style scoped>
	.zt1{
	    width: 100%;
	    height: 60px;
	    line-height: 60px;
	    /* border: solid 2px #383636;; */
	    background:#00a5f8;
	}
	.shij{
	    color:  rgb(235, 235, 235);
	    float: left;
	    margin-left: 10px;
	}

	/* 时间右边 */
	.shijy{
	    float: right;
	    margin-right: 10px;
	}
	.shijy ul li{
	    float: left;
	    margin-left: 20px;
	}
	.shijy ul li a:link{
	    color:  rgb(235, 235, 235);
	    text-decoration: none;
	}
	.shijy ul li a:visited{
	    color:  rgb(235, 235, 235);
	}
	.shijy ul li a:hover{
	    color: rgb(27, 2, 1);
	    text-decoration: none;
	}

	/* 搜索框 */
	.dbu{
	    /* border: solid 2px #000000; */
	    height: 120px;
	}
	.dbu img{
	    width: 240px;
	    height: 120px;
	}
	.dbu2{
	    float: right;
	    margin-right: 20px;
	    width: 200px;
	    height: 30px;
	    border: solid 2px #000000;
	    border-radius: 15px;
	    margin-top: 45px;
	}
	.dbu2 input{
	    float: left;
	    margin-left: 10px;
	    outline: none;
	    border:none;
	    background: none;
	    font-size: 13px;
	    width: 140px;
	    margin-top: 8px;
	}
	.dbu2 button{
	    float: right;
	    margin-right: 8px;
	    margin-top: 4px;
	    outline: none;
	    border:none;
	    background: none;
	    font-size: 15px;
	    color: rgb(129, 129, 129)
	}
</style>
